import { useEffect } from 'react';

import { usePerformanceEventsContext } from 'context/performanceEvents/performanceEvents';
import { PerformanceEvents } from 'interface';
import { checkLoadingLifecycle } from 'utils';

/**
 * This hook is used for sending App Spinner Performance event.
 *
 * @param hashKey - The name of the event, which indicates in which part of the application the loader was called
 * @param isLoading - The flag on which the calculation of the start time and finish time of the event depends
 * @param isAuth - An optional flag is used ony for Auth page, because Auth page doesn't contain isLoading state and checkLoadingLifecycle calling depends on Auth unmounting
 */
export function useLoadingPerformanceEvents(hashKey: string, isLoading: boolean, isAuth?: boolean) {
  const performanceContext = usePerformanceEventsContext();
  const resolveKey = hashKey.toLowerCase();

  useEffect(() => {
    if (isLoading) {
      performanceContext.setStartTime(PerformanceEvents.spinner, resolveKey);
    }

    if (!isLoading && !isAuth) {
      checkLoadingLifecycle(resolveKey, performanceContext);
    }

    return () => {
      if (isAuth) {
        checkLoadingLifecycle(resolveKey, performanceContext);
      }
    };
  }, [isLoading]);
}
